import React, { useMemo } from 'react';
import { IItemForGetShortInfo } from 'types';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import style from './Info.module.scss';

interface IProps {
	customerName: string;
	fetchedRestaurants: IItemForGetShortInfo[];
	IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
	activationSchedule: string;
	deactivationSchedule: string;
}

export const Info: React.FC<IProps> = React.memo(
	({
		customerName,
		fetchedRestaurants,
		IDSelectedRestaurantOnRestPropsPage,
		activationSchedule,
		deactivationSchedule,
	}) => {
		const restaurantName = useMemo(() => {
			return (
				fetchedRestaurants.find((restaurant) => restaurant.id === IDSelectedRestaurantOnRestPropsPage)?.name ||
				'-'
			);
		}, [fetchedRestaurants, IDSelectedRestaurantOnRestPropsPage]);

		return (
			<div className={style.container}>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="customerLabel"
						value={customerName}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="restaurantLabel"
						value={restaurantName}
						useInForm={true}
					/>
				</div>
				<div className={style.item}>
					<FullInfoField
						containerClassName={style.input}
						label="activationScheduleLabel"
						value={activationSchedule}
						useInForm={true}
					/>
					<FullInfoField
						containerClassName={style.input}
						label="deactivationScheduleLabel"
						value={deactivationSchedule}
						useInForm={true}
					/>
				</div>
			</div>
		);
	},
);
